import { Box, createStyles, Theme, WithStyles, withStyles } from '@freighthub/silhouette-core'
import { computed } from 'mobx'
import { observer } from 'mobx-react'
import { Component } from 'react'

import { TActivity } from '../activities/Activity'
import { ActivityFeedIcon } from '../ActivityFeedIcon'
import { Avatar } from '../avatars/Avatar'
import { getUserType } from '../avatars/avatarUtils'
import { Header } from '../avatars/Header'
import { MessageFooter } from './MessageFooter'
import { MsgSection } from './MessageSection'

const jssStyles = (theme: Theme) =>
  createStyles({
    outerContainer: {
      position: 'relative',
      marginTop: theme.spacing(0.5),
      overflow: 'hidden',
    },
    container: {
      display: 'flex',
      position: 'relative',
    },
    avatarContainer: {
      position: 'relative',
    },
    timeline: {
      position: 'absolute',
      width: theme.spacing(1),
      top: theme.spacing(5.5),
      left: theme.spacing(2),
      height: '100%',
      background: `linear-gradient(${theme.palette.grey[200]}, ${theme.palette.grey.main}, ${theme.palette.grey[200]})`,
      borderBottomLeftRadius: '1px',
    },
    outerMessageContainer: {
      width: '100%',
      textAlign: 'left',
      maxWidth: '480px',
    },
    messageContainer: {
      textAlign: 'left',
      margin: theme.spacing(0, 0, 1.25),
    },
    publicMessage: {
      marginTop: 0,
      padding: theme.spacing(1.25),
      background: theme.palette.background.default,
      borderRadius: '16px',
    },
    activityIconContainer: {
      margin: theme.spacing(0, 1, 0, 0.75),
      width: '24px',
      height: '24px',
    },
    whiteMessageContainer: {
      display: 'flex',
      width: '100%',
      padding: '10px',
      backgroundColor: theme.palette.background.paper,
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      boxShadow: `0px 4px 8px 0px ${theme.palette.grey[300]}`,
    },
  })

type TChatMessageProps = {
  handleDownload: (doc: { _id: string; name: string }) => void
  activity: TActivity
  isLast: boolean
  userId?: string
} & WithStyles<typeof jssStyles, false>

class LeanChatMessage extends Component<TChatMessageProps> {
  @computed
  get messageSpecificStyle(): string {
    const { type: activityType } = this.props.activity
    if (activityType === 'message') return this.props.classes.publicMessage
    return ''
  }

  render() {
    const { activity, handleDownload, isLast, classes, userId } = this.props

    // temporary return null for TP events
    // NOTE: Remove once these events are implemented
    if (activity.type === 'transportPlanAlert' || activity.type === 'transportPlanMilestone') return null

    return (
      <div className={classes.outerContainer}>
        <div className={classes.container}>
          <div className={classes.avatarContainer}>
            <Avatar
              avatar={activity.avatar}
              avatarType={activity.avatarType}
              size="large"
              userType={getUserType(userId)}
            />
          </div>
          <Box
            className={classes.whiteMessageContainer}
            sx={(theme) => ({ marginBottom: isLast ? theme.spacing(1.2) : theme.spacing(5) })}
          >
            <div>
              <Header title={activity.title} />
              <MessageFooter messageDate={activity.updatedAt} />
            </div>
            {activity.activityIcon && (
              <div className={classes.activityIconContainer}>
                <ActivityFeedIcon iconType={activity.activityIcon} />
              </div>
            )}
            <Box className={classes.outerMessageContainer}>
              <div
                className={`${classes.messageContainer} ${this.messageSpecificStyle}`}
                data-e2e-id="chat_message-text"
              >
                {activity.messageContent.map((sectionParams, i) => (
                  <MsgSection key={i} section={sectionParams} handleDownload={handleDownload} />
                ))}
              </div>
            </Box>
          </Box>
          <div className={isLast ? '' : classes.timeline} />
        </div>
      </div>
    )
  }
}

export const ChatMessage = withStyles(jssStyles)(observer(LeanChatMessage))
